import type { FunctionComponent } from 'react';

export const CobrainerLogo: FunctionComponent = () => (
    <svg fill="none" height="16" viewBox="0 0 35 16" width="35" xmlns="http://www.w3.org/2000/svg">
        <path
            clipRule="evenodd"
            d="M24.6597 0.397873C24.8155 0.13261 25.2042 0.13261 25.36 0.397873L34.0232 15.1803C34.179 15.4456 33.9846 15.7775 33.673 15.7775H16.346C16.0351 15.7775 15.84 15.4456 15.9958 15.1803L24.6597 0.397873Z"
            fill="#040F16"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M16 8C16 12.4182 12.4182 16 8 16C3.58175 16 0 12.4182 0 8C0 3.58175 3.58175 0 8 0C12.4182 0 16 3.58175 16 8Z"
            fill="#040F16"
            fillRule="evenodd"
        />
    </svg>
);
